import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ReferenceDTO} from '../models/application/ReferenceDTO';

@Injectable({
  providedIn: 'root'
})
export class ReferenceService {
  private url = environment.baseUrl + '/reference';

  constructor(private http: HttpClient) {
  }
  getBy(key: string, fieldName: string): Observable<ReferenceDTO> {
    return this.http.get<ReferenceDTO>(`${this.url}?key=${key}&fieldName=${fieldName}`);
  }
  getAllByFieldName(fieldName: string): Observable<ReferenceDTO[]> {
    return this.http.get<ReferenceDTO[]>(`${this.url}/all?fieldName=${fieldName}`);
  }
  getAllReferencesByFieldNameAndValue(fieldName: string, value: string): Observable<ReferenceDTO[]> {
    const encodedValue = encodeURIComponent(value);
    return this.http.get<ReferenceDTO[]>(`${this.url}/search?fieldName=${fieldName}&value=${encodedValue}`);
  }
}
